import { static_countries } from '../../model/static_countries';
import Select from 'react-select';
import useProxyPoolCreationForm from '../../store/proxyPoolCreationFormStore';
import countryCodeToFlagEmoji from 'country-code-to-flag-emoji';
import { CountryType } from '@fd/common/api/fetchCountryList';

export default function CountrySelect() {
  const { country, setCountry } = useProxyPoolCreationForm();

  const handleChange = (option: CountryType | null) => {
    if (option !== null) setCountry(option);
  };

  return (
    <Select
      value={country}
      onChange={handleChange}
      getOptionLabel={(c) =>
        `${countryCodeToFlagEmoji(c.countryCode)} ${c.countryName}`
      }
      getOptionValue={(c) => c.countryCode}
      options={static_countries}
      placeholder="Select countries"
    />
  );
}
